import React from 'react'
import Layout from '../Layouts/Layout'
import { Helmet } from 'react-helmet-async'
import db from '../db'

export default function PrivacyPolicy () {
  return (
    <Layout>
      <Helmet>
        <title>Məxfilik Siyasəti | Kodart Tətbiq və Təlim Mərkəzi</title>
        <meta name="description" content="Kodart Tətbiq və Təlim Mərkəzinin məxfilik siyasəti. Şəxsi məlumatlarınızın toplanması, istifadəsi və qorunması haqqında ətraflı məlumat." />
        <link rel="canonical" href="https://kodart.az/məxfilik-siyasəti" />
        <meta property="og:type" content="website" />
        <meta property="og:locale" content="az_AZ" />
        <meta property="og:url" content="https://kodart.az/məxfilik-siyasəti" />
        <meta property="og:title" content="Məxfilik Siyasəti | Kodart" />
        <meta property="og:description" content="Kodart Tətbiq və Təlim Mərkəzinin məxfilik siyasəti." />
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Məxfilik Siyasəti | Kodart" />
        <meta name="twitter:description" content="Kodart Tətbiq və Təlim Mərkəzinin məxfilik siyasəti." />
      </Helmet>
      <main data-page='privacy'>
          <section className='section-container'>
            <div className='section-header'>
              <h1>Məxfilik Siyasəti</h1>
              <div className='green-dot-line'></div>
            </div>
            <div className='privacy-content'>
              <p className='privacy-updated'>Son yenilənmə: May 2026</p>

              <div className='privacy-section'>
                <h2>1. Giriş</h2>
                <p>
                  Kodart Tətbiq və Təlim Mərkəzi ("Kodart", "biz") olaraq ziyarətçilərimizin məxfiliyini qorumağı vacib öhdəlik kimi qəbul edirik.
                  Bu siyasət saytımıza — <strong>kodart.az</strong> — daxil olan şəxslərin məlumatlarının necə toplandığını, istifadə olunduğunu və qorundığunu izah edir.
                  Saytdan istifadə etməklə siz bu siyasətin şərtlərini qəbul etmiş hesab olunursunuz.
                </p>
              </div>

              <div className='privacy-section'>
                <h2>2. Hansı məlumatları toplayırıq?</h2>
                <p>Saytımızda aşağıdakı şəxsi məlumatlar toplanıla bilər:</p>
                <ul>
                  <li><strong>Ad, soyad</strong> — geri zəng forması vasitəsilə könüllü olaraq təqdim edilir.</li>
                  <li><strong>Telefon nömrəsi</strong> — geri zəng forması vasitəsilə könüllü olaraq təqdim edilir.</li>
                  <li><strong>Analitik məlumatlar</strong> — saytın ziyarəti zamanı Facebook Pixel texnologiyası vasitəsilə avtomatik toplanır (cihaz növü, səhifə görüntüləmələri və s.).</li>
                </ul>
              </div>

              <div className='privacy-section'>
                <h2>3. Məlumatları necə istifadə edirik?</h2>
                <p>Toplanan məlumatlar aşağıdakı məqsədlər üçün istifadə olunur:</p>
                <ul>
                  <li>Geri zəng sorğularına cavab vermək və sizinlə əlaqə saxlamaq.</li>
                  <li>Xidmət və təlim proqramlarımız haqqında məlumat vermək.</li>
                  <li>Sayt ziyarətçi statistikasını təhlil etmək və xidmətimizi inkişaf etdirmək.</li>
                </ul>
              </div>

              <div className='privacy-section'>
                <h2>4. Məlumatların saxlanması və təhlükəsizliyi</h2>
                <p>
                  Şəxsi məlumatlarınız yalnız sizinlə əlaqə saxlamaq üçün lazımi müddət ərzində saxlanılır.
                  Məlumatlarınız üçüncü şəxslərə satılmır və kommersiya məqsədilə paylaşılmır.
                  Biz məlumatlarınızı icazəsiz girişdən, dəyişdirilmədən və ya məhv edilməkdən qorumaq üçün müvafiq texniki tədbirlər görürük.
                </p>
              </div>

              <div className='privacy-section'>
                <h2>5. Çerezlər (Cookies)</h2>
                <p>
                  Saytımız Facebook Pixel xidmətindən istifadə edir. Bu texnologiya sayt ziyarətçilərinin davranışını izləmək məqsədilə
                  brauzerinizə çerez (cookie) faylları yerləşdirə bilər. Brauzerinizin parametrlərindən çerezləri idarə etmək mümkündür.
                </p>
              </div>

              <div className='privacy-section'>
                <h2>6. Xarici keçidlər</h2>
                <p>
                  Saytımız sosial media səhifələrimizə (Instagram, Facebook, LinkedIn, WhatsApp) keçidlər ehtiva edir.
                  Həmin platformaların öz məxfilik siyasətləri mövcuddur; onların saytlarına daxil olduğunuz zaman bizim siyasətimiz tətbiq olunmur.
                </p>
              </div>

              <div className='privacy-section'>
                <h2>7. Əlaqə</h2>
                <p>Məxfilik siyasətimizlə bağlı hər hansı sualınız olduqda bizimlə əlaqə saxlaya bilərsiniz:</p>
                <ul>
                  <li><strong>E-poçt:</strong> <a href={`mailto:${db.contacts.eMail}`}>{db.contacts.eMail}</a></li>
                  <li><strong>Telefon:</strong> <a href={`tel:${db.contacts.phone}`}>+994 {db.contacts.phone}</a></li>
                  <li><strong>Ünvan:</strong> {db.contacts.address}</li>
                </ul>
              </div>
            </div>
          </section>
        </main>
      </Layout>
  );
}
